import React, { useState } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { getChoiceLabel } from '../rnHelper'
import classnames from 'classnames'
import { RnExerciseSet } from '../rnSlice'
import FooterButtons from '../../common/components/FooterButtons'
import { Question, Choice, QuestionText, ChoiceText } from './commonStyles'
import RulesKeyModal, { ModalType } from './RulesKeyModal'
import { Button } from 'antd'
import { IButton } from '../../../constants/pages'

export interface IRnExerciseProps {
  currentSet: number
  level?: number
  exerciseSet?: RnExerciseSet
  answer?: number
  pickAnswer: (choice: number) => void
  next: () => void
}


const RnExercise = ({ currentSet, level, exerciseSet, answer, pickAnswer, next }: IRnExerciseProps) => {
  const [modalType, setModalType] = useState<ModalType | undefined>(undefined)
  const [showAnswers, setShowAnswers] = useState<boolean>(false)

  if (level === undefined || exerciseSet === undefined) { return null }

  const { question, answers } = exerciseSet

  const handleNext = () => {
    setShowAnswers(false)
    next()
  }

  const answerCols = answers.map((answerText, index) => {
    const buttonClasses = classnames('pt-3', { selected: answer === index })
    return (
      <Col xs={10} sm={8} md={4} key={`answer-${index}`} className="my-1">
        <Choice className={buttonClasses} block onClick={() => pickAnswer(index)}>
          <ChoiceText>{answerText}</ChoiceText>
          <h6>{getChoiceLabel(index)}</h6>
        </Choice>
      </Col>
    )
  })

  const nextButton: IButton = {
    label: "Next",
    disabled: answer === undefined,
    action: handleNext,
    buttonType: "primary"
  }

  const showAnswersButton: IButton = {
    label: "Show Answers",
    action: () => setShowAnswers(true),
    buttonType: "primary"
  }

  const extraL4Instructions = (
    <>
      <p><strong>Adding and subtracting rules to follow</strong></p>
      <ul>
        <li>Add the values of numerals from left to right if the left numeral is greater than or equal to the right numeral.</li>
        <li>Subtract the value of the left numeral from the right numeral if the left numeral is smaller than the right numeral.</li>
      </ul>
    </>
  )

  return (
    <>
      <Container>
        <Row className="mb-2">
          <Col xs={6}>
            <h4>Level {level}</h4>
          </Col>
          <Col xs={6} className="text-right">
            <Button type="primary" className="mr-2" onClick={() => setModalType('key')}>Key</Button>
            <Button type="primary" onClick={() => setModalType('rules')}>Rules</Button>
          </Col>
        </Row>
        <div className="mb-3">
          <h5>Instructions</h5>
          <p>Answer each question by finding the actual number that the Roman numeral represents or by finding which Roman numeral represents the actual number.  It is more challenging to try to complete the exercise without writing down any of the numbers, as it makes your brain work harder.  However, it is a perfectly good and effective exercise if you want to do this as a paper/pencil task.  Familiarize yourself with the rules prior to completing the exercise.  These exercises will be presented in sets of 6.  You will find the right answer at the end of each set.</p>
          {level === 4 && extraL4Instructions}
        </div>
        <Row className="mb-3 justify-content-center">
          <Col xs={12}> 
            <Question className="text-center">
              <h5 className="text-left">{`Set ${currentSet}`}</h5>
              <QuestionText count={question.length}>{question}</QuestionText>
            </Question>
          </Col>
        </Row>
        {
          showAnswers && 
          <Row className="justify-content-center">
            {answerCols}
          </Row>
        }
      </Container>
      <FooterButtons 
        buttons={[showAnswers ? nextButton : showAnswersButton]} 
      />
      <RulesKeyModal type={modalType} close={() => setModalType(undefined)} />
    </>
)
}

export default RnExercise